<template>
  <div>
    <div
      class="card commodity-info"
    >
      <div class="info van-hairline--top">
        <div class="info-header">产品信息</div>
        <van-row class="info-line">
          <van-col :span="24">
            <span class="info-title">商品代码：</span>
            <span class="info-value">{{ orderDetail.materialCode }}</span>
          </van-col>
        </van-row>
        <van-row class="info-line">
          <van-col :span="24">
            <span class="info-title">产品名称：</span>
            <span class="info-value">{{ orderDetail.materialCode }}</span>
          </van-col>
        </van-row>
        <van-row class="info-line">
          <van-col :span="24">
            <span class="info-title">属性描述：</span>
            <span class="info-value">{{ orderDetail.commodityName }}</span>
          </van-col>
        </van-row>
        <van-row class="info-line">
          <van-col :span="24">
            <span class="info-title">生产企业：</span>
            <span class="info-value"> {{ orderDetail.productionEnterprise }}</span>
          </van-col>
        </van-row>
        
        <van-row class="info-line">
          <van-col :span="12">
            <span class="info-title">规格：</span>
            <span class="info-value">{{ orderDetail.commoditySpec }}</span>
          </van-col>
          <van-col :span="12">
            <span class="info-title">包装：</span>
            <span class="info-value">{{ orderDetail.packing }}</span>
          </van-col>
        </van-row>
        <van-row class="info-line">
          <van-col :span="24">
            <span class="info-title">订单重量：</span>
            <span class="info-value">{{ orderDetail.measureUnit }}</span>
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderCommodityCard",
  props: {
    orderDetail: Object,
    advanceSalePlanInfo: Object,
  },
  data() {
    return {
      formInit: {
        orderType: [],
        priceType: [
          {
            itemCode: "02",
            itemName: "定价",
          },
          {
            itemCode: "01",
            itemName: "挂牌",
          },
        ],
        sendType: [
          {
            itemCode: "Z",
            itemName: "直发",
          },
          {
            itemCode: "K",
            itemName: "库发",
          },
          {
            itemCode: "D",
            itemName: "断卖",
          },
        ],
        deliveryType: [
          {
            itemCode: "1",
            itemName: "自提",
          },
          {
            itemCode: "2",
            itemName: "配送",
          },
        ],
        status: [
          //订单状态
          {
            itemName: "已撤销",
            itemCode: "-1",
          },
          {
            itemName: "待提交",
            itemCode: "0",
          },
          {
            itemName: "待确认",
            itemCode: "0_1", //其他交易模式
          },
          {
            itemName: "待确认",
            itemCode: "0_2", //待客户下单
          },
          {
            itemName: "待确认",
            itemCode: "0_3", //业务员初审之后再确认
          },
          {
            itemName: "待审核",
            itemCode: "1",
          },
          {
            itemName: "审核中",
            itemCode: "2",
          },
          {
            itemName: "待发货",
            itemCode: "3",
          },
          {
            itemName: "发货中",
            itemCode: "4",
          },
          {
            itemName: "已完成",
            itemCode: "9",
          },
        ],
      },
    };
  },
  filters: {
    shipModeStatus: function (value) {
      switch (value) {
        case "Z":
          return "直发";
        case "K":
          return "库发";
        case "D":
          return "断卖";
      }
    },

    priceTypeStatus: function (value) {
      switch (value) {
        case "02":
          return "定价";
        case "01":
          return "挂牌";
      }
    },
  },
  created() {
    console.log("orderDetail", this.orderDetail);
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl';

.card {
  margin-top: 24px;
  background: #ffffff;
  padding: 0 24px;
  font-size: 26px;

  .info {
    padding: 16px 0;

    .info-header {
      display: flex;
      justify-content: right;
      align-items: center;
      height: 88px;
      font-size: 32px;

      img {
        width: 40px;
        height: 40px;
        margin-right: 12px;
      }
    }

    .info-line {
      height: 61px;
      line-height: 61px;
      color: #666666;

      span {
        display: inline-block;
      }

      .red {
        color: #E12020;
      }

      .text-red {
        display: inline-block;
        color: #E12020;
        margin-right: 5px;
        margin-left: 5px;
      }

      .textBig-red {
        display: inline-block;
        color: #E12020;
        font-size: 36px;
        margin-right: 5px;
        margin-left: 5px;
      }
    }
  }
}
</style>